import moment from 'moment'

function validateRange(initialDate, finalDate) {
	const momentInitialDate = moment(initialDate, 'YYYY-MM-DD')
	const momentFinalDate = moment(finalDate, 'YYYY-MM-DD')

	const result = { isNotValid: false, message: '' }
	if (!initialDate || !finalDate) return result

	if (momentFinalDate.isAfter(moment()))
		result.message = 'A data final não pode ser maior que a data atual'
	else if (momentInitialDate.isAfter(momentFinalDate))
		result.message = 'A data inicial não pode ser maior que a data final'

	result.isNotValid = result.message.length > 0
	return result
}

function formatDefault(date) {
	const day = `0${date.getDate()}`.slice(-2)
	const month = `0${date.getMonth() + 1}`.slice(-2)
	const formattedDate = `${day}/${month}/${date.getFullYear()}`
	return formattedDate
}

function getHours(dateString) {
	const date = moment(dateString).toDate()
	const hour = `0${date.getHours()}`.slice(-2)
	const minutes = `0${date.getMinutes()}`.slice(-2)
	const hours = `${hour}:${minutes}`

	return hours
}

function getDayOfWeek(date) {
	return [
		'domingo',
		'segunda-feira',
		'terça-feira',
		'quarta-feira',
		'quinta-feira',
		'sexta-feira',
		'sábado',
	][date.getDay()]
}

function getDayMonth(date) {
	const day = ('0' + date.getDate()).slice(-2)
	const month = ('0' + (date.getMonth() + 1)).slice(-2)
	return `${day}/${month}`
}

const minuteMillis = 60 * 1000
const hourMillis = 60 * minuteMillis
const dayMillis = 24 * hourMillis

const getDate = (date) =>
	typeof date === 'string' ? moment(date).toDate() : date

function getFomarttedDiff(date1, date2) {
	const d1 = getDate(date1)
	const d2 = getDate(date2)

	const diff = Math.abs(d1 - d2)
	const days = Math.floor(diff / dayMillis)
	const hours = Math.floor(((diff % dayMillis) - days) / hourMillis)
	const minutes = Math.round(((diff % hourMillis) - hours) / minuteMillis)

	const arr = [`${minutes}min`]
	if (hours > 0) arr.push(`${hours}h`)
	if (days > 0) arr.push(`${days}d`)

	return arr.reduce((acc, item) => `${item} ${acc}`)
}

const extractDate = (date) =>
	new Date(date.getFullYear(), date.getMonth(), date.getDate())

function getDaysDiff(date1, date2) {

	if (!date1 || !date2) {
		return 0
	}

	const d1 = extractDate(getDate(date1))
	const d2 = extractDate(getDate(date2))
	const diff = Math.abs(d1 - d2)
	const daysDiff = Math.floor(diff / dayMillis)

	return daysDiff
}

function getTomorrowDate() {
	let today = new Date()
	today.setDate(today.getDate() + 1)
	return new Date(today)
}

function isValidFutureDate(value) {
	if (!value || value.length < 10) return true
	const date = moment(value, 'YYYY-MM-DD', true)
	return date.isValid() && !date.isBefore(moment().startOf('day'))
}

function formatToYYYYMMDD(date) {
	const momentDate = typeof date === 'string' ? moment(date) : moment(date)
	return momentDate.format('YYYY-MM-DD')
}

export const dateHelper = {
	getHours,
	getDayMonth,
	getDaysDiff,
	getDayOfWeek,
	formatDefault,
	validateRange,
	getFomarttedDiff,
	getTomorrowDate,
	isValidFutureDate,
	formatToYYYYMMDD,
}
